module.exports = __webpack_public_path__ + "img/nccn-logo.3f767905.png";